import Component from '../core/Component'
import anime from 'animejs'

const STATES = {
    ACTIVE: 'is-active',
}

export default class AwardsVisual extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            images: [],
            imgs: [],
            imageInners: [],
            name: null,
            project: null,
        }

        this.state = {
            active: false,
            group: -1,
            id: null,
        }

        this.timers = {
            hide: null,
        }
    }

    prepare() {
        this.element.addEventListener('transitionend', (event) => {
            if (event.target !== this.element) {
                return
            }

            if (!this.is(STATES.ACTIVE)) {
                Object.keys(this.images).forEach(
                    (key) => (this.images[key].element.style.transform = 'translateY(100%)'),
                )
            }
        })
        this.images = this.ref.images.reduce((acc, element, index) => {
            acc[element.dataset.id] = {
                element,
                timestamp: 0,
                animating: false,
                image: this.ref.imgs[index],
                inner: this.ref.imageInners[index],
            }

            return acc
        }, {})
    }

    destroy() {
        clearTimeout(this.timers.hide)
    }

    show({ caption, project, id, group, year }) {
        if (id === this.state.id) {
            return
        }

        this.state.id = id
        clearTimeout(this.timers.hide)
        this.ref.name.textContent = caption + " " + year
        this.ref.project.textContent = project
        this.element.classList.add(STATES.ACTIVE)

        const now = Date.now()
        this.images[id].timestamp = now

        let order = Object.keys(this.images)

        if (!this.images[id].animating && id !== order[0]) {
            order.sort((a, b) => this.images[b].timestamp - this.images[a].timestamp)
            order.forEach(
                (id, index) => (this.images[id].element.style.zIndex = order.length - index),
            )

            const verticalDirection = group > this.state.group ? -1 : 1

            this.state.group = group
            anime({
                targets: this.images[id].element,
                translateY: [`${100 * verticalDirection}%`, 0],
                skewY: [`${10 * verticalDirection}deg`, 0],
                duration: 800,
                easing: 'cubicBezier(.71,0,.19,.99)',
                begin: () => (this.images[id].animating = true),
                complete: () => (this.images[id].animating = false),
            })

            anime({
                targets: this.images[id].inner,
                skewY: [`${-10 * verticalDirection}deg`, 0],
                duration: 800,
                easing: 'cubicBezier(.71,0,.19,.99)',
            })

            anime({
                targets: this.images[id].image,
                scale: [1.5, 1],
                duration: 800,
                easing: 'cubicBezier(.71,0,.19,.99)',
            })
        }

        this.state.active = true
    }

    hide(final = false) {
        this.state.active = false
        if (final) {
            clearTimeout(this.timers.hide)
            this.element.classList.remove(STATES.ACTIVE)
            this.state.group = -1
            this.state.id = null
            return
        }

        this.timers.hide = setTimeout(() => {
            this.state.group = -1
            this.element.classList.remove(STATES.ACTIVE)
        }, 500)
    }
}
